export default {
    'onboarding': {
        component: import('@/components/integrations/protokol/aikbank/Onboarding'),
    }
}